import {
    Checkbox,
    TableCell,
    TableRow,
    Chip
} from '@mui/material';
import { IProgramaFidelidade } from '../../interfaces/IProgramaFidelidade';
import { useDataHora } from '../../../core/hooks/useDataHora';
import { TipoProgramaFidelidade, TipoProgramaFidelidadeDescricao } from '../../enum/TipoProgramaFidelidade';

interface ProgramaFidelidadeTableRowProps {
    programa: IProgramaFidelidade;
    selecionado: boolean;
    toggleSelecionado: (uuid: string) => void;
}

export const ProgramaFidelidadeTableRow = ({ 
    programa, 
    selecionado, 
    toggleSelecionado
}: ProgramaFidelidadeTableRowProps) => {
    const { dataHoraBr } = useDataHora();
    
    const formatarTipo = () => {
        if (programa.tipo === TipoProgramaFidelidade.CASHBACK) {
            return `CASHBACK - ${programa.porcentagemRetorno}%`;
        } else if (programa.tipo === TipoProgramaFidelidade.ITENS) {
            return `ITENS - A cada ${programa.quantidadePedidosNecessarios} pedidos`;
        }
        return TipoProgramaFidelidadeDescricao[programa.tipo as TipoProgramaFidelidade] || programa.tipo;
    };
    
    const formatarConfiguracao = () => {
        if (programa.tipo === TipoProgramaFidelidade.CASHBACK) {
            const partes: string[] = [`Retorno: ${programa.porcentagemRetorno}% do valor do pedido`];
            if (programa.diasVencimentoCashback) {
                partes.push(`Vence em ${programa.diasVencimentoCashback} dia${programa.diasVencimentoCashback !== 1 ? 's' : ''}`);
            }
            if (programa.limiteAcumuloCashback) {
                partes.push(`Limite: R$ ${Number(programa.limiteAcumuloCashback).toFixed(2).replace('.', ',')}`);
            }
            return partes.join(' | ');
        } else if (programa.tipo === TipoProgramaFidelidade.ITENS) {
            const quantidadeProdutos = programa.produtoUuids?.length || 0;
            return `A cada ${programa.quantidadePedidosNecessarios} pedidos - ${quantidadeProdutos} produto${quantidadeProdutos !== 1 ? 's' : ''}`;
        }
        return "-";
    };
    
    const getStatus = () => {
        if (programa.ativo) {
            return { label: "Ativo", color: "success" as const };
        }
        return { label: "Inativo", color: "default" as const };
    };
    
    const status = getStatus();
    
    const formatarData = () => {
        if (!programa.cadastradoAs) return "-";
        try {
            const dataStr = typeof programa.cadastradoAs === 'string' 
                ? programa.cadastradoAs 
                : programa.cadastradoAs.toISOString();
            return dataHoraBr(dataStr);
        } catch (error) {
            return "-";
        }
    };
    
    return (
        <TableRow
            selected={selecionado}
            hover
            role="checkbox"
            aria-checked={selecionado}
        >
            <TableCell padding="checkbox">
                <Checkbox
                    checked={selecionado}
                    onChange={() => programa.uuid && toggleSelecionado(programa.uuid)}
                />
            </TableCell>
            <TableCell align="left" width="25%">
                <Chip 
                    label={formatarTipo()} 
                    color="primary"
                    size="small"
                    variant="outlined"
                />
            </TableCell>
            <TableCell align="center" width="15%">
                <Chip 
                    label={status.label} 
                    color={status.color}
                    size="small"
                />
            </TableCell>
            <TableCell align="left" width="35%">{formatarConfiguracao()}</TableCell>
            <TableCell align="left" width="25%">{formatarData()}</TableCell>
        </TableRow>
    );
};

